// Engineering Skills organized by subcategories
export const ENGINEERING_SKILLS_CATEGORIES = [
  {
    name: 'Mechanical Engineering',
    skills: [
      'CAD Design', 'Thermodynamics', 'Fluid Mechanics',
      'Machine Design', 'Materials Science', 'Structural Analysis',
      'Heat Transfer', 'Manufacturing Processes', 'Quality Control',
      'Product Development', 'Mechanical Testing', 'Prototyping',
      'Failure Analysis', 'Design Optimization', 'Technical Documentation'
    ]
  },
  {
    name: 'Electrical Engineering',
    skills: [
      'Circuit Design', 'Power Systems', 'Electronics',
      'Control Systems', 'Signal Processing', 'Digital Systems',
      'Microcontrollers', 'PCB Design', 'Embedded Systems',
      'Power Electronics', 'Electrical Testing', 'System Integration',
      'Electrical Safety', 'EMC Design', 'Technical Standards'
    ]
  },
  {
    name: 'Civil Engineering',
    skills: [
      'Structural Design', 'Construction Management', 'Geotechnical Engineering',
      'Transportation Engineering', 'Environmental Engineering', 'Hydraulics',
      'Site Planning', 'Materials Testing', 'Project Management',
      'Building Codes', 'Safety Standards', 'Quality Assurance',
      'Cost Estimation', 'Risk Assessment', 'Technical Documentation'
    ]
  },
  {
    name: 'Software Engineering',
    skills: [
      'Software Design', 'Programming', 'System Architecture',
      'Database Design', 'Software Testing', 'Version Control',
      'API Development', 'Security Engineering', 'Performance Optimization',
      'Code Review', 'Documentation', 'Agile Methods',
      'DevOps Practices', 'Quality Assurance', 'Technical Standards'
    ]
  },
  {
    name: 'Chemical Engineering',
    skills: [
      'Process Design', 'Reaction Engineering', 'Separation Processes',
      'Heat Transfer', 'Fluid Dynamics', 'Plant Design',
      'Process Control', 'Safety Management', 'Quality Control',
      'Environmental Compliance', 'Scale-up', 'Process Optimization',
      'Materials Selection', 'Cost Analysis', 'Technical Documentation'
    ]
  },
  {
    name: 'Aerospace Engineering',
    skills: [
      'Aerodynamics', 'Propulsion Systems', 'Aircraft Design',
      'Spacecraft Systems', 'Flight Mechanics', 'Structural Analysis',
      'Avionics', 'Systems Integration', 'Testing Methods',
      'Safety Standards', 'Quality Control', 'Project Management',
      'Performance Analysis', 'Risk Assessment', 'Technical Documentation'
    ]
  },
  {
    name: 'Industrial Engineering',
    skills: [
      'Process Optimization', 'Quality Management', 'Supply Chain Management',
      'Operations Research', 'Ergonomics', 'Facility Planning',
      'Production Planning', 'Inventory Control', 'Lean Manufacturing',
      'Six Sigma', 'Cost Analysis', 'Safety Management',
      'Project Management', 'Data Analysis', 'Technical Standards'
    ]
  },
  {
    name: 'Environmental Engineering',
    skills: [
      'Waste Management', 'Water Treatment', 'Air Quality Control',
      'Environmental Impact', 'Remediation', 'Sustainability',
      'Pollution Control', 'Resource Management', 'Compliance',
      'Risk Assessment', 'Project Management', 'Quality Control',
      'Cost Analysis', 'Technical Documentation', 'Safety Standards'
    ]
  },
  {
    name: 'Biomedical Engineering',
    skills: [
      'Medical Device Design', 'Biomechanics', 'Biomaterials',
      'Clinical Engineering', 'Regulatory Compliance', 'Quality Systems',
      'Product Development', 'Testing Methods', 'Risk Management',
      'Documentation', 'Project Management', 'Safety Standards',
      'Cost Analysis', 'Technical Writing', 'Clinical Trials'
    ]
  },
  {
    name: 'Materials Engineering',
    skills: [
      'Materials Science', 'Material Selection', 'Material Testing',
      'Failure Analysis', 'Surface Engineering', 'Heat Treatment',
      'Corrosion Protection', 'Quality Control', 'Process Development',
      'Documentation', 'Project Management', 'Safety Standards',
      'Cost Analysis', 'Technical Writing', 'Research Methods'
    ]
  },
  {
    name: 'Systems Engineering',
    skills: [
      'Requirements Analysis', 'System Architecture', 'Integration',
      'Verification', 'Validation', 'Risk Management',
      'Configuration Management', 'Quality Assurance', 'Project Management',
      'Documentation', 'Technical Standards', 'Performance Analysis',
      'Cost Analysis', 'Safety Analysis', 'Reliability Engineering'
    ]
  },
  {
    name: 'Control Systems Engineering',
    skills: [
      'Control Theory', 'System Dynamics', 'PID Control',
      'Automation', 'Instrumentation', 'Process Control',
      'System Integration', 'Performance Analysis', 'Testing Methods',
      'Documentation', 'Project Management', 'Safety Standards',
      'Cost Analysis', 'Technical Writing', 'Quality Control'
    ]
  },
  {
    name: 'Manufacturing Engineering',
    skills: [
      'Process Design', 'Production Planning', 'Quality Control',
      'Lean Manufacturing', 'Automation', 'Tool Design',
      'CNC Programming', 'CAM Systems', 'Materials Processing',
      'Documentation', 'Project Management', 'Safety Standards',
      'Cost Analysis', 'Technical Writing', 'Process Optimization'
    ]
  },
  {
    name: 'Energy Engineering',
    skills: [
      'Power Generation', 'Energy Distribution', 'Renewable Energy',
      'Energy Efficiency', 'Grid Systems', 'Energy Storage',
      'System Integration', 'Performance Analysis', 'Project Management',
      'Documentation', 'Technical Standards', 'Safety Compliance',
      'Cost Analysis', 'Environmental Impact', 'Quality Control'
    ]
  },
  {
    name: 'Robotics Engineering',
    skills: [
      'Robot Design', 'Control Systems', 'Sensor Integration',
      'Motion Planning', 'Computer Vision', 'AI Integration',
      'System Integration', 'Performance Analysis', 'Testing Methods',
      'Documentation', 'Project Management', 'Safety Standards',
      'Cost Analysis', 'Technical Writing', 'Quality Control'
    ]
  }
];

// Export flattened list for backward compatibility
export const ENGINEERING_SKILLS = ENGINEERING_SKILLS_CATEGORIES.reduce(
  (acc, category) => [...acc, ...category.skills],
  [] as string[]
);
